// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"125":"comments","138":"profile","236":"actions","261":"new-page","425":"photo","464":"public-profile","506":"author","525":"edit-page","558":"attach-files","587":"ratings","706":"show-private","920":"library","995":"authentication"}[chunkId] || chunkId) + ".bundle.js";
};